import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "container text-center long-container"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-lg-12 news-nav"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "img-container"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "caption long-caption"
};
const _hoisted_8 = {
  class: "date"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
    class: _normalizeClass(["news-style", {
      'active-nav': $setup.isShowNav
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $setup.changeNav('news'))
  }, "公司新闻", 2), _createElementVNode("span", {
    class: _normalizeClass(["news-style", {
      'active-nav': !$setup.isShowNav
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $setup.changeNav('trends'))
  }, "行业动态", 2)])]), _createElementVNode("div", {
    class: _normalizeClass(["row", {
      'active-list-trends': $setup.isShowTrends
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsList, n => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["col-sm-6 col-md-4", {
        'active-list-news': $setup.isShowNews
      }]),
      key: n.id
    }, [_createVNode(_Transition, {
      name: "newsList",
      appear: "",
      class: "animate__animated",
      "enter-active-class": "animate__fadeInUp"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "thumbnail long-thumbnail",
        onClick: $event => $setup.goNewsDetail(n)
      }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        src: n.imgUrl,
        alt: "companyNew"
      }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("h3", null, _toDisplayString(n.title), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(n.releaseDate), 1)])], 8, _hoisted_4)]),
      _: 2
    }, 1024)], 2);
  }), 128))], 2)]);
}